export default function setDate(datepicker) {
    if (datepicker.value.length > 0) {
        const dateArray = datepicker.value.split('-');

        const day = document.getElementById('date-day');
        const month = document.getElementById('date-month');
        const year = document.getElementById('date-year');

        day.value = dateArray[2];
        month.value = dateArray[1];
        year.value = dateArray[0];
    }
}
